import * as Sentry from '@sentry/react';
import { useGateValue, useStatsigClient } from '@statsig/react-bindings';
import { useEffect, useRef } from 'react';
import { reportSentryEventToClarity } from 'util/clarity-error-reporter';
import { getEnv } from 'util/getEnv';
import location from 'util/location';

const SentryWrapper = ({ children }) => {
  const initRef = useRef(false);
  const statsigClient = useStatsigClient();
  const isSentryEnabled = useGateValue('web-ordering-sentry');

  useEffect(() => {
    if (
      !isSentryEnabled ||
      initRef.current ||
      location.getLocationHref().indexOf('localhost') !== -1 ||
      !!window.Cypress ||
      process.env['NODE_ENV'] === 'test'
    )
      return;
    Sentry.init({
      dsn: 'https://72ca72f629cca475721f16fd2ed87202@o4511167351029760.ingest.us.sentry.io/4511180290719744',
      integrations: [
        Sentry.statsigIntegration({ featureFlagClient: statsigClient.client }),
        Sentry.browserTracingIntegration(),
      ],
      environment:
        getEnv('REACT_APP_SENTRY_ENVIRONMENT') || getEnv('REACT_APP_ENV_NAME'),
      release: getEnv('REACT_APP_SENTRY_RELEASE') || undefined,
      tracesSampleRate: 1.0,
      enableLogs: true,
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      beforeSend: reportSentryEventToClarity,
    });
    initRef.current = true;
  }, [statsigClient, isSentryEnabled]);

  return children;
};

export default SentryWrapper;
